import React from 'react';
import { Wallet } from 'lucide-react';
import { BALANCE_LOG_TYPES } from '../constants';

const BalanceTab = ({ balanceData, loading, isAdmin, onOpenAdjust }) => {
  if (loading) return (
    <div className="text-center py-8">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
    </div>
  );

  if (!balanceData) return null;

  return (
    <div className="space-y-4">
      <div className="bg-green-50 border border-green-200 rounded-xl p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500 flex items-center gap-1">
              <Wallet className="w-4 h-4" />当前余额
            </p>
            <p className="text-3xl font-bold text-green-600 mt-1">
              ${parseFloat(balanceData.balance || 0).toFixed(2)}
              <span className="text-sm font-normal text-gray-400 ml-1">USDT</span>
            </p>
          </div>
          {isAdmin && (
            <button onClick={onOpenAdjust}
              className="text-xs px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
              手动调整
            </button>
          )}
        </div>
      </div>

      <div>
        <p className="text-sm font-medium text-gray-700 mb-2">余额流水</p>
        {!balanceData.logs?.length ? (
          <p className="text-xs text-gray-400 text-center py-4">暂无流水记录</p>
        ) : (
          <div className="space-y-2">
            {balanceData.logs.map(log => {
              const typeInfo = BALANCE_LOG_TYPES[log.type] || { label: log.type, color: 'text-gray-600' };
              return (
                <div key={log.id} className="flex items-center justify-between bg-gray-50 rounded-lg px-3 py-2">
                  <div>
                    <p className="text-sm font-medium text-gray-700">{typeInfo.label}</p>
                    <p className="text-xs text-gray-400">{log.notes}</p>
                    <p className="text-xs text-gray-400">
                      {new Date(log.created_at_ts * 1000).toLocaleString()}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className={`text-sm font-bold ${typeInfo.color}`}>
                      {parseFloat(log.amount) > 0 ? '+' : ''}{parseFloat(log.amount).toFixed(2)}
                    </p>
                    <p className="text-xs text-gray-400">余额 ${parseFloat(log.balance_after).toFixed(2)}</p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default BalanceTab;